// extracted by mini-css-extract-plugin
module.exports = {"overlayClass":"AiHeader_overlayClass__WQ98e","activeTabBg":"AiHeader_activeTabBg__etu6G"};